import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { getStaffView } from "../../server/apihelper";
import { Link, useParams } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export const StaffDetails = () => {
  const [staffView, setStaffsView] = useState(null);
  const { id } = useParams();

  useEffect(() => {
    AOS.init();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (!id) return;
      try {
        const res = await getStaffView(id);
        console.log("-------Staff view data:", res?.data);
        if (res && res.data) {
          setStaffsView(res.data);
        }
      } catch (error) {
        console.error("Error fetching staff view:", error);
      }
    };

    fetchData();
  }, [id]);

  return (
    <>
      <div>
        {/* Start Page Banner */}
        <div className="page-banner-area bg-1">
          <div className="container">
            <div className="page-banner-content">
              <h1>Staff Details</h1>
              <ul>
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li className="navspace">
                  <Link to="/staff">Staff</Link>
                </li>
                <li className="navspace">Staff Details</li>
              </ul>
            </div>
          </div>
        </div>
        {/* End Page Banner */}

        {/* <!--Start Courses Details Area--> */}
        <div className="courses-details-area pt-100 pb-70">
          <div className="container">
            <div className="row">
              {staffView ? (
                <div className="col-lg-8">
                  <div className="courses-details">
                    <div className="courses-card">
                      <h2>{staffView.name}</h2>
                      {/* <div className="img">
                        <img src={staffView.profile} alt={staffView.name} width={180} height={180} />
                      </div> */}
                      <p className="text-justify" style={{ textAlign: "justify" }}>
                        {staffView.description}
                      </p>

                    </div>
                    <div className="courses-card">
                      <h2>Qualification</h2>

                      <p className="text-justify" style={{ textAlign: "justify" }}>
                        {staffView.qualification}
                      </p>
                    </div>
                  </div>
                </div>
              ) : (
                <span>Loading...</span>
              )}
              {staffView ? (
                <div className="col-lg-4 staffstyle2">
                  <div className="enroll-courses">
                    <div className="enroll-img">
                      <img
                        className="staffImage"
                        src={staffView.profile}
                        alt={staffView.name}
                        width={300}
                        height={300}
                        style={{ objectFit: 'cover' }}
                      />
                    </div>
                    <div className="list">
                      <ul>
                        <li>
                          <span>Designation :</span>
                          {staffView.designition}
                        </li>

                        {/* <li>
                          <span>Experience :</span>
                          {staffView.experience} years
                        </li> */}
                        <li>
                          <span>Department :</span>
                          {staffView.department}
                        </li>

                        {/* <li>
                          <span>Subject Handling :</span>
                          {staffView.std}
                        </li> */}
                      </ul>
                    </div>
                    {/* <a href="courses.html" class="default-btn btn">
                    Enroll Courses
                  </a> */}
                  </div>
                </div>
              ) : (
                <span>"No Data"</span>
              )}
            </div>
          </div>
        </div>
        {/* <!--End Courses Details Area--> */}
      </div>
    </>
  );
};
